<template>
  <div class="code">
    <PunchCode />
  </div>
</template>

<script>
// @ is an alias to /src
import PunchCode from '@/components/PunchCode.vue'

export default {
  name: 'Code',
  components: {
    PunchCode
  },
  mounted () {
    this.$store.dispatch('traineeStatusModule/setViewedIntro', false);
  }
}
</script>
